import React, { useState } from 'react';
import ResponsiveImage from '@/components/ResponsiveImage';
import { ChevronLeft, ChevronRight } from 'lucide-react';

export default function ChargerImageCarousel({ images }) {
  const [current, setCurrent] = useState(0);

  const prev = (e) => {
    e.stopPropagation();
    setCurrent(i => (i === 0 ? images.length - 1 : i - 1));
  };
  const next = (e) => {
    e.stopPropagation();
    setCurrent(i => (i === images.length - 1 ? 0 : i + 1));
  };

  // Touch swipe support
  const [touchStart, setTouchStart] = useState(null);
  const handleTouchStart = (e) => setTouchStart(e.touches[0].clientX);
  const handleTouchEnd = (e) => {
    if (touchStart === null) return;
    const diff = touchStart - e.changedTouches[0].clientX;
    if (diff > 50) next(e);
    else if (diff < -50) prev(e);
    setTouchStart(null);
  };

  return (
    <div className="relative w-full aspect-[4/3] bg-gray-900 rounded-xl overflow-hidden group"
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
    >
      <ResponsiveImage
        src={images[current].url}
        width={800} height={600} widths={[400, 640, 960]}
        sizes="(max-width: 767px) 100vw, 50vw"
        alt={images[current].alt}
        className="w-full h-full object-cover transition-opacity duration-300"
      />

      {/* Caption */}
      {images[current].caption && (
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent px-4 py-3">
          <p className="text-[11px] text-white/80">{images[current].caption}</p>
        </div>
      )}

      {/* Arrows */}
      {images.length > 1 && (
        <>
          <button type="button" aria-label="Previous image" onClick={prev} className="absolute left-2 top-1/2 -translate-y-1/2 w-8 h-8 rounded-full bg-black/40 text-white flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
            <ChevronLeft className="w-5 h-5" />
          </button>
          <button type="button" aria-label="Next image" onClick={next} className="absolute right-2 top-1/2 -translate-y-1/2 w-8 h-8 rounded-full bg-black/40 text-white flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
            <ChevronRight className="w-5 h-5" />
          </button>
        </>
      )}

      {/* Dots */}
      {images.length > 1 && (
        <div className="absolute top-3 right-3 flex gap-1.5">
          {images.map((_, i) => (
            <button key={i} type="button" aria-label={`View image ${i + 1}`} aria-current={i === current ? 'true' : undefined} onClick={(e) => { e.stopPropagation(); setCurrent(i); }}
              className={`w-2 h-2 rounded-full transition-all ${i === current ? 'bg-white w-4' : 'bg-white/40'}`}
            />
          ))}
        </div>
      )}
    </div>
  );
}